import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import privateLibraryActions from 'redux/actions/privateLibraryActions'
import AddToFolder from 'views/modals/add_to_folder_modal'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { privateLibrarySelectors } from 'redux/selectors'

class PrivateLibraryAddToFolderModal extends React.Component {

	constructor() {
		super()
		this.createNewFolder = this.createNewFolder.bind(this)
		this.saveLesson = this.saveLesson.bind(this)
		this.cancelAction = this.cancelAction.bind(this)
	}

	createNewFolder() {
		const type = this.props.entity.entityType==='1'?'Presentation':'Bundle'
		const entity_id = this.props.entity.entityType==='3'?this.props.entity.entityUID:this.props.entity.entityID
		this.props.actions.openNewFolderModalWithEntity(entity_id, type)
	}

	saveLesson(folder_id) {
		const entity_id = this.props.entity.entityType==='3'?this.props.entity.entityUID:this.props.entity.entityID
		const lessons = [], bundles = []
		if (this.props.entity.entityType === '1') {
			lessons.push(entity_id)
		} else {
			bundles.push(entity_id)
		}
		this.props.actions.addLessonToFolder(lessons, bundles, folder_id)
	}

	cancelAction() {
		this.props.actions.closeModal()
	}

	render() {
		return (
			<AddToFolder
				closeModal={this.props.actions.closeModal}
				cancel={this.cancelAction}
				modalName={this.props.modalName}
				modalTitle={this.props.modal_title}
				createNewText={this.props.createNewText}
				folderName={this.props.folderName}
				createNewFolder={this.createNewFolder}
				folders={this.props.folders}
				saveLesson={this.saveLesson} />
		)
	}
}

PrivateLibraryAddToFolderModal.propTypes = {
	modalName: PropTypes.string,
	entityUID: PropTypes.string,
	entityType: PropTypes.string,
}

function mapStateToProps(state) {
	return privateLibrarySelectors.getAdminAddToFolderViewData(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: privateLibraryActions.addLessonToFolderCancel,
		addLessonToFolder: privateLibraryActions.addLessonToFolder,
		openNewFolderModalWithEntity: privateLibraryActions.openNewFolderModalWithEntity,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLibraryAddToFolderModal)
